
import { Vue, Component, Prop } from 'vue-property-decorator';
import UiButton from '@/components/button/ui-button.vue';

import BillingInfo from './components/billing-info.vue';
import PaymentPlan from './components/payment-plan.vue';
import SubsPlan from './components/subcription-plan.vue';
import ManagerInfo from './components/manager-count.vue';
import UpgradeSubcription from './dialog/upgrade-subscription.vue';

import AddAddtionalManager from './dialog/add-addtional-manager.vue';

import lambdaRequest from '@/helpers/lambdaRequest';

import GET_SUBSCRIPTIONS_DETAILS from '@/apollo/payment/GetSubscriptionsDetails.gql';
import GET_PAYMENT_CARDS from '@/apollo/payment/GetPaymentCards.gql';

import { Company, User, Payment_Card } from '@/generated/graphql';

import getActiveManagersCountCondition from '@/helpers/queryConditions/getActiveManagersCountCondition';

import { SubscriptionStatus } from '@/entities/payment/SubscriptionStatus';

import { SubscriptionPlansInnerNames } from '@/entities/payment/InnerNames';
import subscriptionPresentationDetails from '@/data/subscriptionPresentationDetails';

import { NOTIFICATION } from '@/entities/Events';
import Message, { MessageDuration } from '@/data/notificationsMessages';

@Component({
	components: {
		PaymentPlan,
		BillingInfo,
		SubsPlan,
		ManagerInfo,
		UpgradeSubcription,
		AddAddtionalManager,
		UiButton,
	},
	apollo: {
		paymentCardsFullInfo: {
			query: GET_PAYMENT_CARDS,
			variables() {
				return {
					userId: this.currentUser.id,
					subscriptionId: this.currentSubscriptionId,
				};
			},
			update(data) {
				this.paymentCards = data.payment_card;
			},
		},
	},
})
export default class PaymentV2 extends Vue {
	@Prop({ type: Object, required: true }) readonly company!: Company;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	currentSubscription = null;
	totalEnterManagers = 0;
	showConfirmModal = false;
	upgradingSubcription = null;
	showAddAddtionalManagerDialog = false;
	buttonLoading = false;
	allSubscriptionPlans = [];

	paymentCards: Payment_Card[] = [];

	plans = [
		{
			price: '43',
			planName: 'Starter',
			totalManager: 1,
			description: 'Ideal for small businesses ready to grow.',
		},
		{
			price: '99',
			planName: 'Growth',
			totalManager: 5,
			description:
				'For growing businesses that are ready to take control of their flexible workforce.',
		},
		{
			price: '149',
			planName: 'Premium',
			totalManager: 20,
			description:
				'Across your company or across the globe, all the tools to meet your flexible resourcing needs.',
		},
	];
	get currentSubscriptionId(): string {
		return this.currentUser.admin!.company.subscriptions[0]?.id;
	}
	get isTrialPeriod(): boolean {
		return (
			this.company.subscriptions[0]?.status === SubscriptionStatus.TRIALING
		);
	}
	get getCancelAt(): boolean {
		return this.currentSubscription?.cancel_at_period_end;
	}
	get paymentCardsExist(): boolean {
		return this.paymentCards.length > 0;
	}
	get showAddAddtionalManager(): boolean {
		return (
			this.currentSubscription?.subscription_plan?.inner_name ===
			SubscriptionPlansInnerNames.PREMIUM
		);
	}
	handleClose(): void {
		this.showConfirmModal = false;
	}
	get isReachedFiftyLimit() {
		if(this.currentSubscription?.subscription_plan?.inner_name === 'PREMIUMPLUSFIFTY') return true;
		return false;
	}
	get isPremimumOrGreaterThen() {
		// let selectionIndex = null;

		// let planIndex = null;

		// this.allSubscriptionPlans?.forEach((plan, index) => {
		// 	if (
		// 		plan.inner_name ===
		// 		this.currentSubscription?.subscription_plan?.inner_name
		// 	) {
		// 		selectionIndex = index;
		// 		if (plan.name === 'Premium') {
		// 			planIndex = index;
		// 		}
		// 	} else if (plan.name === 'Premium') {
		// 		planIndex = index;
		// 	}
		// });

		// return (
		// 	selectionIndex !== null &&
		// 	planIndex !== null &&
		// 	selectionIndex >= planIndex
		// );
		if(this.currentSubscription?.status === 'active') {
			return true;
		}
		else{
			return false;
		}
	}
	handleConfirmUpgrade() {
		this.subscribeToAnotherPlan(this.upgradingSubcription);
	}
	HandleAddAdditionalManager() {
		const index = this.allSubscriptionPlans.findIndex(
			(item) =>
				Number(item.price) ===
				Number(this.currentSubscription.subscription_plan.price) + 2000
		);
		if (index > -1) {
			this.subscribeToAnotherPlan(this.allSubscriptionPlans[index].id);
		}
	}
	async restoreSubscription(subId = this.currentSubscription.id): Promise<void> {
		await lambdaRequest({
			lambdaName: 'restoreSubscription',
			requestData: {
				subscription_id: subId,
			},
		});
		await this.refreshData();
		this.$eventBus.emit(
			NOTIFICATION,
			Message.successMessage('Successfully Activited subscription')
		);
		
	}

	async subscribeToAnotherPlan(subscriptionPlanId: string): Promise<void> {
		this.buttonLoading = true;
		await lambdaRequest({
			lambdaName: 'subscribeToAnotherPlan',
			requestData: {
				company_id: this.company.id,
				subscription_plan_id: subscriptionPlanId,
				current_subscription_id: this.currentSubscription.id,
			},
		});
		this.$eventBus.emit(
			NOTIFICATION,
			Message.successMessage('Successfully upgraded subscription')
		);
		await this.refreshData();

		this.buttonLoading = false;
		this.showConfirmModal = false;
		this.showAddAddtionalManagerDialog = false;
	}

	async handleConfirmationDialog(subscriptionPlanId, subscriptoin) {
		if (!this.paymentCardsExist) {
			this.$router.push(`/profile/user`);
			return;
		}
		// if (this.currentSubscription?.cancel_at_period_end) {
		if (subscriptionPlanId === subscriptoin.subscription_plan_id &&  subscriptoin?.cancel_at_period_end) {
			this.restoreSubscription();
			return;
		}

		this.upgradingSubcription = subscriptionPlanId;
		this.showConfirmModal = true;
	}

	created() {
		 this.refreshData()
	}
	async refreshData() {
		await this.$apollo
			.query({
				query: GET_SUBSCRIPTIONS_DETAILS,
				variables: {
					companyId: this.company.id,
					userId: this.currentUser.id,
					activeManagersCountCondition:
						getActiveManagersCountCondition(this.company.id),
				},
				fetchPolicy: 'network-only',
			})
			.then((result) => {
				const displaySubscription =
					result.data.subscription_plan.filter(
						(item) =>
							item.inner_name ===
								SubscriptionPlansInnerNames.STARTER ||
							item.inner_name ===
								SubscriptionPlansInnerNames.GROWTH ||
							item.inner_name ===
								SubscriptionPlansInnerNames.PREMIUM
					);
				this.allSubscriptionPlans = result.data.subscription_plan;
				this.plans = displaySubscription.map((item) => {
					return {
						id: item.id,
						price: String(Number(item.price) / 100),
						planName: item.name,
						totalManager:
							item.subscription_plan_access_permission
								.managers_count,
						description:
							subscriptionPresentationDetails[item.inner_name]
								.slogan,
					};
				});
				this.currentSubscription = result.data.subscription[0];
				this.totalEnterManagers =
					result.data.activeManagersCount.aggregate.count;
			})
			.catch(console.error);
	}
}
